import { render } from "./DataTableAssignments.vue?vue&type=template&id=3b87440e&ts=true"
import script from "./DataTableAssignments.vue?vue&type=script&lang=ts"
export * from "./DataTableAssignments.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/com.latudio.www.teachers_staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__